import { Link, useLocation, useNavigate } from "react-router-dom";
import { AdmAuthAPI } from "../api";
import "../styles_admin.scss";
document.body.classList.add("type-"+process.env.REACT_APP_STYLE);

export default function AdmNav() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const onLogout = () => { AdmAuthAPI.logout(); nav("/adm/login", { replace: true }); };

  const item = (to, label) => (
    <li key={to} className={pathname.startsWith(to) ? "active" : ""}>
      <Link to={to}>{label}</Link>
    </li>
  );

  return (
    <div id="admHrd">
      <div>
        <h1><a href="/adm/branch">{process.env.REACT_APP_CLINIC_NAME} 관리자</a></h1>
        <nav className="adm-nav">
          <ul>
            {item("/adm/branch", "지점관리")}
            {item("/adm/user", "회원관리")}
            {item("/adm/userDayLog", "일별 사용량")}
            {item("/adm/userTimeLog", "시간별 사용량")}
            <li className="right"><button onClick={onLogout}>로그아웃</button></li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
